$(document).ready(function() {
    $(".new-testimonials-container").each((_, elem) => {
        $(elem).flickity({
            "prevNextButtons": false,
            "wrapAround": true,
            "groupCells": 1,
            "draggable": true,
            "dragThreshold": 15,
            "pauseAutoPlayOnHover": false,
            "autoPlay": false,
            "pageDots": false,
            "arrowShape": {"x0": 20, "x1": 60, "y1": 40, "x2": 60, "y2": 35, "x3": 25},
            "adaptiveHeight": false
        })
    });
});